module.exports = __webpack_public_path__ + "media/images/icons/material/warning-654eadc94fc5ba22e3a98732840ee6e7.svg";